import { createRouter, createWebHistory } from 'vue-router'
import { TokenService } from 'src/services/TokenService'

import { Routes } from './routes'

import { Permission } from 'src/models/Permission'
import { hasPermission } from 'src/services/PermissionService'
import { RegexHelper } from '@helpers/RegexHelper'
import { UserDataService } from '@services/UserDataService'

const NotFound = () => import('../components/NotFound.vue')
const Login = () => import('../components/login/LoginView.vue')
const RecoverPassword = () =>
  import('../components/RecoverPassword/RecoverPasswordView.vue')
const EsriRegister = () =>
  import('../components/login/esri-conference/EsriRegisterView.vue')
const MainLayout = () => import('../components/layout/MainLayout.vue')

const BulletinMakerVue = () =>
  import('../components/bulletins/BulletinMaker/BulletinMaker.vue')
const MainMeteo = () => import('../components/meteo/MainMap.vue')
const MainIncendios = () => import('../components/incendios/MainMap.vue')
const MapMosaic = () => import('../components/mosaic/MapMosaic.vue')
const MainReport = () => import('../components/report/MainReport.vue')
const BulletinsView = () => import('@components/bulletins/BulletinsView.vue')
const CompareView = () =>
  import('@components/mainmap/ComparationView/ComparationView.vue')
const SimulationMap = () => import('../components/simulation/SimulationMap.vue')
const NewsAndAdvice = () =>
  import('../components/global/newsAndAdvice/NewsAndAdviceView.vue')

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: Routes.LOGIN,
      name: 'Login',
      component: Login
    },
    {
      path: '/esri-conference-registration',
      name: 'Register',
      component: EsriRegister
    },
    {
      path: '/forgottenPassword',
      name: 'Recover Password',
      component: RecoverPassword,
      beforeEnter: (to, from, next) => {
        const id = to.query.id as string

        if (!id || (id && !RegexHelper.validateUUID(id))) {
          next(Routes.LOGIN)
        } else {
          next()
        }
      }
    },
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: Routes.METEO,
          name: 'Meteorología',
          component: MainMeteo,
          meta: {
            permission: Permission.ACCESO_METEO
          }
        },
        {
          path: Routes.MOSAIC,
          name: 'Mosaico',
          component: MapMosaic,
          meta: {
            permission: Permission.ACCESO_MOSAICO
          }
        },
        {
          path: Routes.INFORME,
          name: 'Informe',
          component: MainReport,
          meta: {
            permission: Permission.ACCESO_INFORME
          }
        },
        {
          path: Routes.COMPARAR,
          name: 'Comparar',
          component: CompareView,
          meta: {
            permission: Permission.ACCESO_COMPARACION
          }
        },
        {
          path: Routes.INCENDIOS,
          name: 'Incendios',
          component: MainIncendios,
          meta: {
            permission: Permission.ACCESO_INCENDIOS
          }
        },
        {
          path: Routes.SIMULADOR,
          name: 'Simulador',
          component: SimulationMap,
          props: true,
          meta: {
            permission: Permission.ACCESO_SIMULADOR
          }
        },
        {
          path: Routes.NEWS_AND_ADVICE,
          name: 'News and advice',
          component: NewsAndAdvice
        },
        {
          path: Routes.BULLETINS,
          meta: {
            permission: Permission.ACCESO_CONFIGURADOR_BOLETINES
          },
          children: [
            {
              path: '',
              name: 'Boletines',
              component: BulletinsView
            },
            {
              path: 'new',
              name: 'New Bulletin',
              component: BulletinMakerVue
            },
            {
              path: ':id',
              name: 'Bulletin',
              component: BulletinMakerVue,
              props: true
            }
          ]
        }
      ]
    },

    {
      path: '/404',
      name: 'PageNotExists',
      component: NotFound
    },
    {
      // Capturar rutas no existentes
      path: '/:catchAll(.*)',
      redirect: '/404'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // const token = TokenService.getLoginToken()
  const isTokenValid =
    (await TokenService.validateToken()) && UserDataService.hasUserData()

  if (
    !isTokenValid &&
    to.path !== Routes.LOGIN &&
    to.path !== Routes.ESRI_CONFERENCE_REGISTRATION &&
    to.path !== Routes.RESTABLECER_PASSWORD
  ) {
    next(Routes.LOGIN)
  } else if (isTokenValid && to.path === Routes.LOGIN) {
    return next(Routes.METEO)
  } else {
    const permission = to.meta?.permission as Permission | undefined
    if (permission) {
      if (hasPermission(permission)) {
        next()
      } else {
        next('/*')
      }
    } else {
      next()
    }
  }
})

export default router
